import { withContext } from 'components/withContext';
import { createContext } from 'react';

const Bitrix24Context = createContext();
const Bitrix24Consumer = withContext(Bitrix24Context, 'bitrix24');

export { Bitrix24Context, Bitrix24Consumer };
